import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { dispatch } from '../store';

type RefreshState = {
  isLoading: boolean;
  tooltipTitle: string;
  hasRefreshAction: boolean;
};

const initialState: RefreshState = {
  isLoading: false,
  tooltipTitle: '',
  hasRefreshAction: false,
};

const refreshSlice = createSlice({
  name: 'refresh',
  initialState,
  reducers: {
    setRefreshStatus(state, action: PayloadAction<{ hasAction: boolean; tooltipTitle?: string }>) {
      state.hasRefreshAction = action.payload.hasAction;
      state.tooltipTitle = action.payload.tooltipTitle ?? '';
    },
    setIsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
  },
});

export default refreshSlice.reducer;

// Actions
export const { setRefreshStatus, setIsLoading } = refreshSlice.actions;

// Global refresh callback management
// Since Redux state shouldn't hold non-serializable data like functions,
// we keep the actual callback in a module-level variable.
let refreshCallback: (() => Promise<void>) | null = null;

export const registerRefreshAction = (
  callback: (() => Promise<void>) | null,
  tooltipTitle?: string
) => {
  refreshCallback = callback;
  dispatch(
    refreshSlice.actions.setRefreshStatus({
      hasAction: !!callback,
      tooltipTitle,
    })
  );
};

export const executeRefreshAction = async () => {
  if (refreshCallback) {
    await refreshCallback();
  }
};

export const setRefreshLoading = (isLoading: boolean) => {
  dispatch(refreshSlice.actions.setIsLoading(isLoading));
};
